import { TimeElapsed } from '@missionlabs/smartagent-app-components'
import React from 'react'

interface Props {
    time: number
}

export const Footer: React.FC<Props> = ({ time }) => (
    <footer>
        <div className="row between middle">
            <span>00:00</span>
            <span>
                {' '}
                <TimeElapsed noTick date={TimeElapsed.from(time)} />{' '}
            </span>
        </div>
    </footer>
)
